import React from "react";
import SiteHeader from "../components/SiteHeader.jsx";
import SiteFooter from "../components/SiteFooter.jsx";
import FeedbackSection from "../components/FeedbackSection.jsx";

export default function Feedback() {
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="feedback-page">
      <SiteHeader />
      <main className="flex-1">
        <FeedbackSection />
      </main>
      <SiteFooter />
    </div>
  );
}
